import { useParams } from 'react-router-dom';
import SubCategoryPage from './productCategories/subCategoryPage/SubCategoryPage';
import { RealEstateSubCategory } from '../lazyImports';

const DynamicSubCategoryPage = () => {
  const { category, sub_category } = useParams();

  switch (category) {
    case 'real-estate':
      return <RealEstateSubCategory />;

    default:
      // Remount per subcategory so page/filters reset (and page 1 is what
      // gets prefetched from category links).
      return <SubCategoryPage key={`${category}/${sub_category}`} />;
  }
};

export default DynamicSubCategoryPage;
